export const PLAN_CARD_TEMPLATE_OPTION = {
  A: "A",
  B: "B",
};

export const COVERAGE_DETAIL_TEMPLATE_OPTION = {
  A: "A",
  B: "B",
};
